import { render, staticRenderFns } from "./WordMDDocViewer.vue?vue&type=template&id=602948f6&scoped=true&"
import script from "./WordMDDocViewer.vue?vue&type=script&lang=js&"
export * from "./WordMDDocViewer.vue?vue&type=script&lang=js&"
import style0 from "./WordMDDocViewer.vue?vue&type=style&index=0&id=602948f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602948f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('602948f6')) {
      api.createRecord('602948f6', component.options)
    } else {
      api.reload('602948f6', component.options)
    }
    module.hot.accept("./WordMDDocViewer.vue?vue&type=template&id=602948f6&scoped=true&", function () {
      api.rerender('602948f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/FileViewers/WordMDDocViewer.vue"
export default component.exports